// Impressum.jsx
import React from 'react';
import { FileText, Phone, Mail, Award, ChevronRight } from 'lucide-react';

export default function Impressum() {
  const sections = [
    {
      icon: FileText,
      title: "Betreiber der Webseite",
      items: [
        "Dr. med. Lothar Boso, Facharzt für Innere Medizin und Rheumatologie",
        "Arzt für Allgemeinmedizin",
        "Wahlarzt",
        "Waldburgstraße 1",
        "6714 Nüziders, Österreich",
        "Mitglied der Ärztekammer für Vorarlberg, Schulgasse 17, 6850 Dornbirn (www.aekvbg.or.at)",
        "Mitglied der Österreichischen Ärztekammer, Weihburggasse 10-12, A-1010 Wien (www.aek.or.at)",
        "Berufsbezeichnung: Facharzt für Innere Medizin und Rheumatologie (verliehen in Österreich)",
        "Tätigkeit unterliegt dem Ärztegesetz 1998 (siehe www.ris.bka.gv.at/bundesrecht)"
      ]
    },
    {
      icon: Phone,
      title: "Kontakt",
      items: [
        "Telefon: 05552/22025",
        "Mobil: +43 664 5749684",
      ]
    },
    {
      icon: Mail,
      title: "Haftungshinweis",
      items: [
        "Trotz sorgfältiger Bearbeitung kann keine Gewähr für die Richtigkeit und Vollständigkeit der Inhalte übernommen werden.",
        "Für externe Links wird keine Verantwortung übernommen, da die Inhalte fremder Seiten nicht beeinflusst werden können."
      ]
    },
    {
      icon: Award,
      title: "Webseite erstellt von",
      items: [
        "Samuel Boso, Webentwicklung & Design",
        
      ]
    }
  ];

  return (
    <section className="services">
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">Impressum</h2>
          <p className="section-description">
            Hier finden Sie alle wichtigen Angaben zum Betreiber dieser Webseite.
          </p>
        </div>

        <div className="services-grid">
          {sections.map((section, index) => {
            const IconComponent = section.icon;
            return (
              <div key={index} className="service-card">
                <div className="service-icon">
                  <IconComponent color="white" size={32} />
                </div>
                <h3 className="service-title">{section.title}</h3>

                <ul className="service-list">
                  {section.items.map((item, i) => (
                    <li key={i}>
                      <ChevronRight className="service-list-icon" size={24} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
